import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const ServiceDetail = lazy(() => import('../pages/services/detail/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const PortfolioDetail = lazy(() => import('../pages/portfolio/detail/page'));
const RequestService = lazy(() => import('../pages/request-service/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogDetail = lazy(() => import('../pages/blog/detail/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/:id',
    element: <ServiceDetail />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/portfolio/:id',
    element: <PortfolioDetail />,
  },
  {
    path: '/request-service',
    element: <RequestService />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:id',
    element: <BlogDetail />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
